import React, { createContext, useContext, useState, useCallback } from 'react';
import { UserContext } from '../../../../../../platform/components/auth/auth-context';
import { CALENDAR_VIEWS, readCalendarView, saveCalendarView } from '../../../../../../platform/util/calendarViewPreference';
import MonthView from './monthView';
import WeekView from './weekView';
import YearView from './yearView';
import DayView from './dayView';

// Create Context for Calendar Views
const CalendarViewsContext = createContext();


export const CalendarViewsProvider = ({ children, defaultView = 'day', allowWeek = true, compact = false }) => {
    const { providerUser } = useContext(UserContext);
    const userId = providerUser?.userId;
    const [selection, setSelection] = useState(() => ({ userId, view: readCalendarView(userId) }));
    const preferredView = (selection.userId === userId ? selection.view : readCalendarView(userId)) || defaultView;
    const view = compact
        ? (['agenda', 'month'].includes(preferredView) ? 'agenda' : 'day')
        : !allowWeek && preferredView === 'week' ? 'day' : preferredView;
    const setView = useCallback(nextView => {
        if (!CALENDAR_VIEWS.includes(nextView)) return;
        saveCalendarView(userId, nextView);
        setSelection({ userId, view: nextView });
    }, [userId]);
    return (
        <CalendarViewsContext.Provider value={{ MonthView, DayView, WeekView, YearView, view, setView }}>
            {children}
        </CalendarViewsContext.Provider>
    );
};

// Custom hook to access Calendar Views Context
export const useCalendarViews = () => {
    const context = useContext(CalendarViewsContext);
    if (context) return context;

    return {
        MonthView,
        DayView,
        WeekView,
        YearView,
        view: 'month',
        setView: () => {},
    };
};

